import { useAgeGate } from "@/hooks/useAgeGate";
import { trackAgeGateAccept, enableAfterAgeGate } from "@/analytics/analytics";

interface Props {
  children: React.ReactNode;
}

export function AgeGate({ children }: Props) {
  const { accepted, accept } = useAgeGate();

  if (accepted) return <>{children}</>;

  function handleAccept() {
    accept();
    trackAgeGateAccept();
    enableAfterAgeGate();
  }

  function handleDecline() {
    window.location.replace("/exit");
  }

  return (
    <div className="min-h-screen bg-surface-0 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-surface-1 rounded-2xl p-8 shadow-2xl border border-surface-3 text-center">
        <div className="text-5xl mb-4">🔞</div>
        <h1 className="text-2xl font-bold mb-2">Age Verification</h1>
        <p className="text-zinc-400 mb-6">
          This site contains adult content. You must be 18 years or older to continue.
        </p>
        <div className="flex gap-3">
          <button
            onClick={handleAccept}
            className="flex-1 bg-accent hover:bg-accent-hover text-white font-semibold py-3 px-6 rounded-lg transition-colors"
          >
            I am 18 or older
          </button>
          <button
            onClick={handleDecline}
            className="flex-1 bg-surface-2 hover:bg-surface-3 text-zinc-300 font-semibold py-3 px-6 rounded-lg transition-colors"
          >
            I am under 18
          </button>
        </div>
        <p className="mt-4 text-xs text-zinc-600">
          Your choice is stored locally and expires after 365 days.
        </p>
      </div>
    </div>
  );
}
